import Vue from 'vue'
import {
  telefoneDoResponsavel as routingTelefoneResponsavel,
  telefoneDoTecnico as routingTelefoneTecnico,
  telefoneDaIndustria as routingTelefoneIndustria,
  telefoneDoCliente as routingTelefoneCliente,
  telefone as routingTelefone
} from '../util/routes'

export default {
  state: {
    telefone: {}
  },
  mutations: {
    setTelefone: (state, payload) => {
      state.telefone = payload
    }
  },
  actions: {
    async getTelefoneDaIndustria ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routingTelefone}/${id}`)
      commit('setTelefone', data)
    },
    async postSaveTelefoneNaIndustria ({ state }, { key }) {
      const { telefone } = state
      if (telefone.id) {
        return Vue.axios.put(
          `${routingTelefone}/${telefone.id}`,
          telefone
        )
      }
      return Vue.axios.post(
        `${routingTelefoneIndustria}`,
        telefone,
        {
          headers: {
            industria: key
          }
        }
      )
    },
    async getTelefoneDoCliente ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routingTelefone}/${id}`)
      commit('setTelefone', data)
    },
    async postSaveTelefoneNoCliente ({ state }, { key }) {
      const { telefone } = state
      if (telefone.id) {
        return Vue.axios.put(
          `${routingTelefone}/${telefone.id}`,
          telefone
        )
      }
      return Vue.axios.post(`${routingTelefoneCliente}`, telefone, {
        headers: {
          cliente: key
        }
      })
    },
    async getTelefoneDoResponsavel ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routingTelefone}/${id}`)
      commit('setTelefone', data)
    },
    async postSaveTelefoneDoResponsavel ({ state }, { key }) {
      const { telefone } = state
      if (telefone.id) {
        return Vue.axios.put(
          `${routingTelefone}/${telefone.id}`,
          telefone
        )
      }
      return Vue.axios.post(`${routingTelefoneResponsavel}`, telefone, {
        headers: {
          responsavel: key
        }
      })
    },
    async getTelefoneDoTecnico ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routingTelefone}/${id}`)
      commit('setTelefone', data)
    },
    async postSaveTelefoneDoTecnico ({ state }, { key }) {
      const { telefone } = state
      if (telefone.id) {
        return Vue.axios.put(
          `${routingTelefone}/${telefone.id}`,
          telefone
        )
      }
      return Vue.axios.post(`${routingTelefoneTecnico}`, telefone, {
        headers: {
          tecnico: key
        }
      })
    },
    async deleteTelefone ({ state }) {
      const { telefone } = state
      return Vue.axios.delete(`${routingTelefone}/${telefone.id}`)
    }
  },
  getters: {
    telefone: ({ telefone }) => telefone
  }
}
